import { render, staticRenderFns } from "./confirm-subscription.vue?vue&type=template&id=4a615c36&"
import script from "./confirm-subscription.vue?vue&type=script&lang=js&"
export * from "./confirm-subscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports